import capitalize from 'lodash/capitalize';

import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type UserUpdatedProps = {
  entry: UserAuditLogEntry<'USER_UPDATED'>;
};

export const UserUpdated = ({ entry }: UserUpdatedProps): JSX.Element => {
  const updatedFields = Object.keys(entry.updates).map((key) => ({
    label: capitalize(key.replaceAll('_', ' ')),
    value: entry.updates[key],
  }));
  const deletedFields = entry.deletes.map((field) => ({
    label: capitalize(field.replaceAll('_', ' ')),
    value: '*DELETED*',
  }));

  return (
    <UserActivityCard
      entry={entry}
      color={statusColors.info}
      icon="pen"
      title="Updated"
      fields={updatedFields.concat(deletedFields)}
    />
  );
};
